import React from "react";
import HeaderPanel from "../../components/layout/HeaderPanel";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { ChooseConfigPane } from "../../components/configuration/ChooseConfigPane";

export const ChooseConfigPage: React.FunctionComponent = () => {
  return (
    <>
      <HeaderPanel applyPadding>{formatMessage("cof.access.accesses")}</HeaderPanel>
      <ChooseConfigPane />
    </>
  );
};
